import React from "react";
import { animated } from '@react-spring/web';
import { transparentWhite } from "./constants";
import { stickyStyled, withMobileSticky } from "@components/sticky";
import { useAnimatedStick } from "./useAnimatedStick";

const Wrapper = stickyStyled(animated.div)`
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  border-top: 1px solid ${transparentWhite};
`;

const AnimatedWrapper = withMobileSticky(React.forwardRef((props, ref) => {
  const { isStuck, style, className, ...otherProps } = props;
  const stuckSpring = useAnimatedStick(isStuck);

  return (
    <Wrapper
      {...otherProps}
      ref={ref}
      className={className}
      style={{ ...style, ...stuckSpring }}
    />
  );
}));

// const AnimatedWrapper = withMobileSticky(React.forwardRef((props, ref) => {
//   const {isStuck, style, className, ...otherProps} = props;
//   const stuckSpring = useAnimatedStick(isStuck);

//   return (
//     <Wrapper {...otherProps} ref={ref} className={className} style={{...style, ...stuckSpring}} />
//   )
// }));

export default AnimatedWrapper;